module.exports = __webpack_public_path__ + "img/xmcs.ebfbe03c.png";